module.exports = __webpack_public_path__ + "prod/1.2.3/img/logo-black.82062643.svg";